import {
  OreTable,
  OreTableActions,
  OreTableBody,
  OreTableCell,
  OreTableContainer,
  OreTableHead,
  OreTableRow,
  OreText,
} from '@edenredespana/oreneta'
import { useTranslation } from 'react-i18next'

import { TableHeadersModel } from '@/Shared/domain/models/TableHeadersModel'
import { ContactModel } from '@/Store/domain'
import { createApiStoreRepository } from '@/Store/infrastructure'
import { useStoreContactsController } from '@/Store/ui/hooks'
import { StoreContactRow } from '@/Store/ui/molecules'
import { storesTranslation } from '@/Store/ui/storesTranslation'
import { useUserData } from '@/User/ui/context'

export const StoreContactsList = (): JSX.Element => {
  const { t } = useTranslation()

  const { merchant } = useUserData()
  const { storeContacts } = useStoreContactsController(
    createApiStoreRepository(),
    merchant.id,
  )

  const contactsHeaders: TableHeadersModel[] = [
    {
      key: 'name',
      label: storesTranslation.contacts.table.headers.name,
      size: 'auto',
    },
    {
      key: 'email',
      label: storesTranslation.contacts.table.headers.email,
      size: 'auto',
    },
    {
      key: 'phone',
      label: storesTranslation.contacts.table.headers.phone,
      size: 'auto',
    },
    {
      key: 'position',
      label: storesTranslation.contacts.table.headers.position,
      size: 'auto',
    },
  ]

  return (
    <OreTableContainer>
      <OreTable>
        <OreTableHead valign="middle">
          <OreTableRow hover={false}>
            {contactsHeaders.map((header: TableHeadersModel) => (
              <OreTableCell as="th" key={header.key} size={header.size}>
                {header.label && t(header.label)}
              </OreTableCell>
            ))}
          </OreTableRow>
        </OreTableHead>
        <OreTableBody valign="top">
          {storeContacts
            ? storeContacts.map((contact: ContactModel, index: number) => {
                return <StoreContactRow key={`p_${index}`} contact={contact} isNursery={merchant.isNursery} />
              })
            : null}
        </OreTableBody>
      </OreTable>
      {!storeContacts || storeContacts.length === 0 ? (
        <OreTableActions>
          <OreText size="text-sm" tone="neutral-600" data-testid="noContacts">
            {t(storesTranslation.contacts.table.noResults)}
          </OreText>
        </OreTableActions>
      ) : null}
    </OreTableContainer>
  )
}
